import { render } from "./Slips.vue?vue&type=template&id=15b2013b"
import script from "./Slips.vue?vue&type=script&lang=js"
export * from "./Slips.vue?vue&type=script&lang=js"

import "./Slips.vue?vue&type=style&index=0&id=15b2013b&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__